const cropper = {
  obj: null
}

export default cropper

export function setCropper (obj) {
  cropper.obj = obj
}
export function getCropper () {
  return cropper.obj
}
